import { Component } from '@angular/core';
import { AuthLayoutComponent } from "../../_layouts/auth-layout/auth-layout.component";
import { MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { UserService } from '../../../Dashboard/_services/users.service';
import { AlertService } from '../../../Dashboard/_services/alert.service';

@Component({
    selector: 'app-forgot-password',
    imports: [AuthLayoutComponent, MatCardTitle, MatCardContent, MatIconModule, FormsModule, RouterLink],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  forgotPassEmail: string = '';
  submitting = false;
  sent = false;

  constructor(
    private router: Router,
    private usersService: UserService,
    private alertService: AlertService,
  ) {}

  onSubmit(form: NgForm) {
    if (form.invalid || this.submitting) {
      form.control.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.usersService.resetPassword(this.forgotPassEmail.toLowerCase()).subscribe({
      next: () => {
        this.submitting = false;
        this.sent = true;
        this.alertService.alert('Check your email for a link to choose a new password', 'success');
      },
      error: (error) => {
        this.submitting = false;
        let errorMessage = 'Something went wrong';
        if (error.error?.statusCode === 401) {
          errorMessage = 'Invalid credentials!';
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        }
        this.alertService.alert(errorMessage, 'error');
      },
    });
  }
}
